import { AgentsBoxCard } from '@motorway/motorway-handshake-components';

import { Header } from '../../components/Header/Header';
import { SignOut } from '../../components/SignOut/SignOut';
import { VehicleCard } from '../../components/VehicleCard/VehicleCard';
import { snowplowCtaClick } from '../../helpers/snowplow';

import styles from './Cancelled.module.scss';

export const Cancelled = () => (
  <div className={styles.component}>
    <Header>
      <h1>The purchase has been cancelled</h1>
      <p>Motorway is processing the request and will be in contact as soon as possible.</p>
      <SignOut />
    </Header>
    <AgentsBoxCard clickCallback={snowplowCtaClick} />
    <VehicleCard />
  </div>
);
